import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService, EnvironmentViewModel } from '../../../Environments';
import { TenantService } from '../../../Services';
import { AirswebInstanceService, NewAirswebInstanceModel, UserCreateMode } from './Services/provisioning.service';
import { MessageJobSeverity } from '@app/Enums';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatCard, MatCardTitle, MatCardSubtitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatFormField, MatPrefix, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { JobLiveViewComponent } from '../../../Jobs/job.liveview.component';

const EmailRegex = /^[a-zA-Z0-9.!#$%&'’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

@Component({
    selector: 'my-package',
    templateUrl: './airsweb.new.component.html',
    styleUrls: ['../../../provisioning.css'],
    imports: [MatButton, FormsModule, MatCard, MatCardTitle, MatCardSubtitle, MatCardContent, MatRadioGroup, MatRadioButton, MatFormField, MatIcon, MatPrefix, MatInput, MatSuffix, MatSelect, MatOption, MatCheckbox, MatCardActions, JobLiveViewComponent]
})
export class NewAirswebComponent implements OnInit {
    adding: boolean;
    instance = new NewAirswebInstanceModel();
    provisioningInProgress: boolean;
    emailRegex = EmailRegex;
    environments: EnvironmentViewModel[];
    provisioningJob: string;
    userMode: UserCreateMode = UserCreateMode.AddMe;
    constructor(
        private tenantService: TenantService,
        private provService: AirswebInstanceService,
        private envService: EnvironmentService,
        private router: Router
    ) {
        this.instance = new NewAirswebInstanceModel();
    }

    ngOnInit() {
        this.instance.ClientId = this.tenantService.selectedTenant.Value;
        this.instance.TenantId = this.tenantService.selectedTenant.TenantId;

    }

    startProvisioning() {
        this.adding = true;
        this.getEnvironments();
    }

    getEnvironments() {
        this.envService
            .getEnvironments()
            .subscribe(envs => this.environments = envs.filter(e => e.AirswebCompatible));
    }
    submitForm() {
        this.adding = false;
        this.provisioningInProgress = true;
        this.provService.provisionNew(this.instance)
            .subscribe(jobId => this.provisioningJob = jobId);

    }
    jobComplete(event: MessageJobSeverity) {
        if (event === MessageJobSeverity.Success) {
            this.tenantService.getTenants()
                .then(r => {
                    setTimeout(() => {
                        this.router.navigate(['/tenant', this.tenantService.selectedTenant.TenantId, 'airsweb']);
                    }, 1000);
                });
        }
    }

    escapeRegExp(string: string) {
        if (!string) {
            return string;
        }

        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
}
